<template>
	<div id="app">
		<template v-if="!activity">
			<el-container>
				<el-header height="auto">
					<Header/>
				</el-header>
				<el-main>
					<router-view/>
				</el-main>
				<el-footer height="auto">
					<Footer/>
				</el-footer>
			</el-container>
		</template>
		<template v-else>
			<router-view/>
		</template>
		
		<Public/>
	</div>
</template>
<script setup>
import Public from "@/components/Public.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {onMounted, ref, watch, getCurrentInstance} from "vue";
import bus from "@/plugins/bus";

const internalInstance = getCurrentInstance()
const vm = internalInstance?.proxy

const activity = ref(false)

watch(
	() => vm.$route,
	(route) => {
		activity.value = route.matched.some(r => r.path === '/activity');
	},
	{immediate: true}
)

onMounted(() => {
	bus.emit('memberInfo')
	bus.emit('getSiteSetting')
	bus.emit('uuid');
})
</script>

<style lang="scss">
html, body {
	padding: 0;
	margin: 0;
	width: 100%;
	min-width: 1220px;
}

#app {
	//font-family: 'times new roman', times, serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	//text-align: center;
	color: #2c3e50;
}

nav {
	padding: 30px;
}

nav a {
	font-weight: bold;
	color: #2c3e50;
}

nav a.router-link-exact-active {
	color: #42b983;
}

.el-header {
	display: flex;
	box-shadow: 4px 2px 2px #d2d0d0;
	background: #fff;
	padding: 0 !important;
	box-sizing: content-box !important;
	justify-content: center;
	position: sticky;
	top: 0;
	width: 100%;
	min-width: 1218px;
	z-index: 3;
}

.el-main {
	padding: 0 !important;
	min-height: 500px;
}

.el-footer {
	//margin-top: 50px;
	width: 100%;
	background: #231815;
	height: auto;
	position: relative;
	padding: 20px 0 !important;
}
</style>
